






















import Vue from 'vue'
import * as echarts from 'echarts'
import cyFormat from '@/utils/cyFormat'
import EchartsHourly from './EchartsHourly'
import windElement from "@/utils/windElement";
import moment, { Moment } from 'moment'
export default Vue.extend({
  props: {
    data: { type: Object }
  },
  data() {
    return {
      hourData: [] as any[],
    }
  },
  watch: {
    data() {
      this.echarts()
    },
  },
  mounted() {
    this.echarts()
  },
  methods: {
    echarts() {
      const dom: any = document.getElementById('echartsHour')
      const myChart: any = echarts.init(dom) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应

      const { temperature, skycon, wind, precipitation } = this.data
      const hourData: any[] = []
      // let temskyCon = ''
      for (let i = 0; i < temperature.length; i++) {
        const item: any = temperature[i];
        //@ts-ignore
        const e: any = skycon[i];
        const windItem: any = wind[i];
        const preItem: any = precipitation[i];
        let getHour = moment(e.datetime).format('HH') + ':00'
        if (i === 0) {
          getHour = '现在'
        }else{
          if(getHour ==='00:00'){
            getHour = '明天'
          }
        }
        // let skyconText = ''
        // let imgUrl = ''
        // if (temskyCon !== e.value) {
        //   skyconText = cyFormat.getSkyconDesc(e.value)
        //   imgUrl = `/static/weatherIcon/${e.value}.png`
        // }
        // temskyCon = e.value
        //@ts-ignore
        hourData.push({
          hour: getHour,
          skyconText: cyFormat.getSkyconDesc(e.value),
          imgUrl: `/static/weatherIcon/${e.value}.png`,
          windDirection: windElement.windDirection(windItem.direction) + "风",
          windSpeed: windElement.windLevel(Math.round(windItem.speed * 10) / 10) + "级",
          precipitation: Math.round(preItem.value * 10) / 10
        })
      }
      this.hourData = hourData
      myChart.setOption(EchartsHourly(temperature, skycon))
    },
  }
})
